// AI Generated
import { Component, Input, Output, EventEmitter, OnInit, forwardRef } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'documents-button',
    template: `<pages-button [ngModel]="ngModel" [text]="text" [textPlural]="textPlural" (callback)="callback.emit()"></pages-button>`,
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DocumentsButtonComponent),
            multi: true,
        },
    ],
})
export class DocumentsButtonComponent implements ControlValueAccessor, OnInit {
    @Input() ngModel: number = 0;
    @Input() text?: string | undefined;
    @Input() textPlural?: string | undefined;
    @Output() callback = new EventEmitter<void>();

    model: number = 0;
    private _onChange = (value: boolean) => {};
    private _onTouched = () => {};
    public _isTouched = false;
    disabled = false;

    constructor (private translateService: TranslateService) {}

    writeValue (obj: any): void {
        this.model = obj;
    }
    registerOnChange (fn: any): void {
        this._onChange = fn;
    }
    registerOnTouched (fn: any): void {
        this._onTouched = fn;
    }
    setDisabledState? (isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    ngOnInit () {
        this.model = parseInt(String(this.ngModel));
        if (this.model == 1) {
            this.text = this.text || this.translateService.getString('document');
        } else {
            this.text = this.textPlural || this.text || this.translateService.getString('documents');
        }

        this.textPlural = this.textPlural || this.text;
    }
}
